import { PEV } from "../../../common/utils";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as service from "../userDetail/service";

const initialState = {
  userDetail: PEV({
    data: {},
  }),
};

const getUserDetail = createAsyncThunk("userDetail/fetch", async () => {
  return await service.fetchUserDetail();
});

const userDetailSlice = createSlice({
  name: "userDetail",
  initialState,
  reducers: {},
  extraReducers: {
    [getUserDetail.pending.type]: (state) => {
      state.userDetail = PEV({ ...state.userDetail }, "Fetching current user");
    },
    [getUserDetail.fulfilled.type]: (state, action) => {
      state.userDetail = PEV({
        data: action.payload,
      });
    },
    [getUserDetail.rejected.type]: (state) => {
      state.userDetail = PEV({ ...state.userDetail }, null, "Error while fetching current user");
    },
  },
});

export const UserDetailReducer = userDetailSlice.reducer;
export const UserDetailActions = { getUserDetail };
